<template>
  <div >
    <van-nav-bar
      :title="stationInfo.name"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
      :fixed="true"
    />
    <div class="body">
      <van-cell-group>
      <van-cell title="名称" :value="stationInfo.name" />
      <van-cell title="设备号" :value="stationInfo.sn" />
      <van-cell title="详细地址" :value="stationInfo.address" />
      <van-cell title="状态" :value="stationInfo.status" />
      <van-cell title="微站参数" :value="stationInfo.station_param" />
      <van-cell title="电费方式" :value="stationInfo.charge_type" />
      <van-cell title="街道办" :value="stationInfo.jiedaoban" />
      <van-cell title="勘察人员" :value="stationInfo.kancha_people" />
      <van-cell title="勘察人员Tel" :value="stationInfo.kancha_people_tel" />
      <van-cell title="安装人员" :value="stationInfo.anzhuang_people" />
      <van-cell title="安装人员Tel" :value="stationInfo.anzhuang_people_tel" />
    </van-cell-group>
    <van-panel title="安装前照片" style="text-align: left">
      <van-row>
        <van-col span="6" v-for="(img,idx) in imgList1" :key="idx">
          <div class="van_content" v-show="stationInfo.pic1"  >
            <div @click="preview(imgList1,idx)" class="img_file" :style="{backgroundImage:'url(' +img_url+ img + '?x-oss-process=image/resize,h_400)'}"></div>
          </div>
        </van-col>
      </van-row>    
    </van-panel>

    <van-panel title="安装后照片"  style="text-align: left">
      <van-row>
        <van-col span="6" v-for="(img,idx) in imgList2" :key="idx">
          <div class="van_content" v-show="stationInfo.pic2">
            <div @click="preview(imgList2,idx)" class="img_file" :style="{backgroundImage:'url(' +img_url+ img + '?x-oss-process=image/resize,h_400)'}"></div>
          </div>
        </van-col>
      </van-row>       
    </van-panel>
    </div>
    
  </div>
</template>

<script>

import { ImagePreview,Dialog,Toast  } from 'vant';
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      stationInfo:{},
      img_url:'http://jnwz.oss-cn-qingdao.aliyuncs.com/images/',
      img_instance:''
    }
  },
  computed:{
    imgList1(){
      return this.imgStrToList(this.stationInfo.pic1)
    },
    imgList2(){
      return this.imgStrToList(this.stationInfo.pic2)
    }
  },
  mounted(){
    this.getStationInfo()
  },
  methods:{
    getStationInfo(){
      var self = this
      this.axios_base.get('yc2/getWZinfo?station_id='+this.$route.params.station_id).then(function(resp){
        self.stationInfo = resp.data[0]
      })
    },
    imgStrToList(img_str){
      if (img_str){
        var img_list = img_str.split(',')
        return img_list
      }else{
        return ''
      }
    },
    preview(imgList,idx){
      var preview_list = []
      for (var i in imgList){
        preview_list.push(this.img_url + imgList[i])
      }
      const img_instance=ImagePreview(preview_list, idx);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van_content{
  display: inline-block;
  height: 80px;
}
.img_file{
  display: inline-block;
  height: 80px;
  width: 80px;
  background-position:center;
  background-repeat:no-repeat;
  background-size:80px auto;
  border-radius: 5px;
  margin:5px 5px 0 5px ;
}
</style>



// WEBPACK FOOTER //
// src/pages/application/stationInfo.vue